var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Activity"},[_c('div',{staticClass:"presentationActivity"},_vm._l((_vm.presentationList),function(item){return _c('PresentationBox',{key:item.id,attrs:{"presentationData":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }